import { i18n } from 'src/boot/i18n';

export default {
  methods: {
    getDocTypeLabel(row: any): string {
      let label = '';
      try {
        const translation_key = row.translation_key
          ? row.translation_key
          : row.type;
        const translation = this.translateDocType(translation_key);

        label = '-';
        if (row.hasOwnProperty('title') && row.title !== '') {
          label = row.title;
        } else {
          label = translation;
        }

        if (translation !== translation_key) {
          label = translation;
        }
      } catch (err) {
        logError(err);
      }
      return label;
    },

    displayDocType(type: string): string {
      if (!type) {
        return '-';
      }
      // Strip trailing UUID suffix (some doc_type values are namespaced
      // per-org with a `_<uuid>` suffix; the translation key is the base).
      const baseType = type.replace(
        /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
        '',
      );
      // Tolgee keys are snake_case lowercase. Backend can send "INVOICE",
      // "Cost Invoice", or "credit_note" — normalize before lookup.
      const key = baseType.toLowerCase().replace(/\s+/g, '_');
      const translation = i18n.t(key);
      // i18n.t returns the key on miss — fall back to the raw value with
      // underscores replaced by spaces and Title Cased for readability.
      if (translation !== key) return translation;
      return baseType
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b[a-z]/g, (m) => m.toUpperCase());
    },

    translateDocType(translation_key: string): string {
      if (!translation_key) return '';
      const key = translation_key.toLowerCase().replace(/\s+/g, '_');
      return i18n.t(key);
    },

    getDocTypeForDisplay(row: any): string {
      if (!row.doc_type) {
        return '';
      }
      const type = row.sub_doc_type ? row.sub_doc_type : row.doc_type;
      return String(type);
    },
  },
};
